module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e03a57a998de396f7a89ac47d0214769.png";